export default __webpack_public_path__ + "static/media/certificateBackground.93e05bf4.png";